<template>
    <div v-if="hasAuth('Department') || hasAuth('DepartmentManager')">
        <list-container :header="translate('department.departments')" v-show="!$route.params.id" :showSearch="true" @search="searchDepartments">
            <template v-slot:commands>
                <excel-exporter table-id="departmentExport" :columns="columns" url="/department/get" modelName="Department"  orderBy="Name"></excel-exporter>
                <button class="btn btn-primary" @click="$router.push({ name:'DepartmentDetail', params: { id: '000000000000000000000000' } })">
                    {{translate('department.newDepartment')}}
                </button>
            </template>
            <list  ref="departments" :columns="columns" url="/department/get" modelName="Department"  orderBy="IsActive desc, Name" :predicate="predicate">

            </list>
        </list-container>
        <router-view v-if="$route.params.id"/>
    </div>
    <div v-else class="alert alert-danger">
        {{translate('errors.notAuthorizedForTheProcess')}}
    </div>
</template>

<script>
import Vue from 'vue'
import list from '../components/List.vue'
import listContainer from '../components/ListContainer.vue'
import ExcelExporter from '../components/ExcelExporter.vue';


export default {
    data(){
        return {
            predicate: "",
            columns : [
                {
                    Key: "Name",
                    Title: this.translate('categoryList.columns.name'),
                    SortField: "Name"
                },
                {
                    Key: "Email",
                    Title: this.translate('login.email'),
                    SortField: "Email"
                },
                {
                    Key: "IsActive",
                    Title: this.translate('categoryList.columns.active'),
                    SortField: "IsActive",
                    Class: "text-center", 
                    Content(i) {
                        return Vue.filter('checkicon')(i.IsActive);
                    }
                }
            ]
        }
    },
    components: {
        list,ExcelExporter,
        listContainer
    },
    methods: {
        searchDepartments(searchText) {
        var parts = [];
        console.log(searchText);

        if (searchText != "")
            parts.push(
            ` Name.ToLower().Contains("${searchText.toLowerCase()}")`
            );

        this.predicate = parts.join(" && ");
        this.$refs.departments.predicate = this.predicate;
        this.$refs.departments.getData();
        },
    },
}
</script>